import React from 'react';
import { Card, CardBody, CardHeader, Col } from 'reactstrap';
import { H5, Progressbar } from '../../../../AbstractElements';
import { CustomHeightcode, ProgressAnimatedcode, ProgressAnimatedtext, ProgressAnimatedtext2, ProgressBarsAnimated, To } from '../../../../Constant';

const Animated = () => {
  return (
    <Card>
      <CardHeader className='pb-0'>
        <H5>{ProgressBarsAnimated}</H5>
        <span>
          {ProgressAnimatedtext} <code>{ProgressAnimatedcode}</code> {To} <code>{CustomHeightcode} </code> {ProgressAnimatedtext2}
        </span>
      </CardHeader>
      <CardBody className='card-body progress-showcase row'>
        <Col>
          <Progressbar color='primary' value='10' animated={true} />
          <Progressbar color='secondary' value='25' animated={true} />
          <Progressbar color='success' value='50' animated={true} />
          <Progressbar color='info' value='75' animated={true} />
        </Col>
      </CardBody>
    </Card>
  );
};

export default Animated;
